<template>
  <div class="live-frame" :class="{ collapsed: isCollapsed }">
    <div class="video-container" style="height: 160px">
      <iframe
        v-if="!isCollapsed"
        :src="liveUrl"
        style="border: none; overflow: hidden; height: 160px"
        scrolling="no"
        frameborder="0"
        allowTransparency="true"
        allowFullScreen="true"
      ></iframe>
    </div>
    <button
      class="toggle-btn"
      :title="isOnline ? this.$i18n.t('watchRelation') : this.$i18n.t('relationOffline')"
      type="button"
      @click="isOnline ? toggleFrame() : null"
    >
      <span :class="['status', isOnline ? 'status--rec' : 'status--offline']"></span>
      <span v-if="isOnline" class="status--online">online</span>
      <span v-else class="status--offline">offline</span>
      {{ $t("liveRelation") }}
    </button>
  </div>
</template>

<script>
import LiveConfig from "../../public/liveConfig.json"
export default {
  name: "LiveFrame",

  props: {
    isOnline: Boolean,
    liveUrl: String,
  },

  data() {
    return {
      isCollapsed: true,
      ...LiveConfig,
    }
  },

  methods: {
    toggleFrame: function () {
      this.isCollapsed = !this.isCollapsed
    },
  },
}
</script>

<style scoped lang="scss">
.live-frame {
  margin: 1rem 1rem 0;
  width: 100%;
  max-width: 20rem;
  width: 18rem;
  background: #000;
  box-shadow: 0 0 1rem rgba(#000, 0.35);
  position: fixed;
  right: 0;
  bottom: 0;

  .video-container {
    opacity: 1;
    max-height: 30rem;
    visibility: visible;
    overflow: hidden;
    transition: opacity 250ms, max-height 250ms;

    video {
      width: 100%;
      display: block;
    }
  }

  .toggle-btn {
    text-align: left;
    font-weight: bold;
    background: #fff;
    padding: 1rem;
    width: 100%;

    &:hover {
      background: $light;
    }
  }

  &.collapsed {
    .video-container {
      opacity: 0;
      max-height: 0;
      visibility: collapse;
    }
  }
}

.status {
  &::before {
    content: "";
    width: 0.45rem;
    height: 0.45rem;
    border-radius: 50%;
    background: currentColor;
    display: inline-block;
    margin-right: 0.25rem;
  }

  &--online {
    color: red;
  }
  &--rec {
    color: red;
    animation: blinker 2s linear infinite;
    @keyframes blinker {
      50% {
        opacity: 0;
      }
    }
  }

  &--offline {
    color: gray;
  }
}
</style>
